import {Observable} from 'rxjs';
import {APIResponse, PagingResponse, PresignedURL} from '@core/interfaces/system/system-common';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

export enum FileFormatType {
    MS_EXCEL = 'MS_EXCEL',
    CSV = 'CSV',
    JPG = 'JPG',
    JPEG = 'JPEG',
    PNG = 'PNG',
    PDF = 'PDF',
    INVALID = 'INVALID',
}

export const FileFormatTypeLabels = {
    [FileFormatType.MS_EXCEL]: 'xlsx',
    [FileFormatType.CSV]: 'csv',
    [FileFormatType.JPG]: 'jpg',
    [FileFormatType.JPEG]: 'jpeg',
    [FileFormatType.PNG]: 'png',
    [FileFormatType.PDF]: 'pdf',
    [FileFormatType.INVALID]: '',
};

export interface Document {
    id: number;
    createdOn: Date;
    updatedOn: Date;
    fileFormat: FileFormatType;
    fileName: string;
    fileKey: string;
    fileSize: number;
    bucketName: string;
    datasetType: string;
    relatedEntity: string;
    userName: string;
    userId: string;
    tag: string;
    documentFunctionType?: DocumentFunctionType;
}

export interface DocumentDto {
    fileFormat: FileFormatType;
    fileName: string;
    fileKey: string;
    bucketName: string;
    documentType: EnginDocumentType;
    relatedEntity: string;
    userId: string;
    userName: string;
    tag: string;
    documentFunctionType: DocumentFunctionType;
    fileSize: number;
    description: string;
    url: string;
}

export enum EnginDocumentType {
    ASSET = 'ASSET',
}

export interface DocumentCreate {
    fileFormat: FileFormatType;
    fileName: string;
    fileKey: string;
    fileSize: number;
    bucketName: string;
    documentType: string;
    relatedEntity: string;
    userName: string;
    userId: string;
    tag: string;
    description: string;
    documentFunctionType: DocumentFunctionType;
}

export interface DocumentAssetImage {
    id: number;
    assetId: number;
    fileName: string;
    documentFunctionType: DocumentFunctionType;
    description: string;
    tag: string;
    url: string;
    fileFormat?: FileFormatType;
}

export interface DocumentImage {
    id: number;
    fileName: string;
    description: string;
    url: string;
    fileFormat?: FileFormatType;
}

export enum DocumentFunctionType {
    NONE = 'NONE',
    LAYOUT_DIAGRAM = 'LAYOUT_DIAGRAM',
}

export const DocumentFunctionTypeLabels = {
    [DocumentFunctionType.NONE]: 'None (default)',
    [DocumentFunctionType.LAYOUT_DIAGRAM]: 'Layout Diagram (will be shown in the Geospatial)',
};

export abstract class DocumentService {
    abstract listFiles(assetId: string): Observable<DataSource>;
    /*
     * Operational
     */
    abstract create(document: DocumentCreate): Observable<APIResponse<Document>>;

    abstract update(documentId: number, document: any): Observable<APIResponse<Document>>;

    abstract delete(documentId: number): Observable<APIResponse<boolean>>;

    abstract getPresignedUrl(fileName: string, fileFormat: string): Observable<APIResponse<PresignedURL>>;

    abstract uploadToPresignedUrl(url: string, data: File);

    /*
     * Retrieval
     */
    abstract getAssetImageDocuments(assetId: string): Observable<APIResponse<DocumentAssetImage[]>>;

    abstract getDocumentListWithUrls(paramsString: string): Observable<PagingResponse<DocumentDto>>;

    abstract findOne(documentId: string): Observable<APIResponse<Document>>;

    abstract getSearchTag(searchString: string): Observable<string[]>;
    abstract getAllTags(assetId: string): Observable<APIResponse<string[]>>;
}
